import { render, staticRenderFns } from "./AdminVersionTab.vue?vue&type=template&id=6684b264&"
import script from "./AdminVersionTab.vue?vue&type=script&lang=ts&"
export * from "./AdminVersionTab.vue?vue&type=script&lang=ts&"
import style0 from "./AdminVersionTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
